// Centers the CRM customer account and makes it feel like a focused workspace instead of a side drawer.
const ID='vc-customer-account-centering';
const install=()=>{
  if(document.getElementById(ID)) return;
  const s=document.createElement('style');
  s.id=ID;
  s.textContent=`
    .vc-account-overlay{
      align-items:center!important;
      justify-content:center!important;
      padding:20px!important;
      box-sizing:border-box!important;
    }
    .vc-account-drawer{
      width:min(980px,94vw)!important;
      height:min(860px,92dvh)!important;
      border:1px solid rgba(96,165,250,.22)!important;
      border-radius:18px!important;
      box-shadow:0 28px 90px rgba(0,0,0,.65)!important;
      overflow:hidden!important;
    }
    .vc-account-head{
      padding:18px 20px 14px!important;
    }
    .vc-account-body{
      overflow-y:auto!important;
      overscroll-behavior:contain!important;
      -webkit-overflow-scrolling:touch!important;
    }
    .vc-account-tabs{
      justify-content:center!important;
    }
    @media(max-width:700px){
      .vc-account-overlay{padding:8px!important;align-items:stretch!important}
      .vc-account-drawer{width:100%!important;height:calc(100dvh - 16px)!important;border-radius:14px!important}
      .vc-account-tabs{justify-content:flex-start!important}
    }
  `;
  document.head.appendChild(s);
};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',install,{once:true}); else install();
export {};
